import { getApiKey } from "../../utils/apiKey";
import React, { Component } from "react";
import Header from "../header";
import CartItem from "./cartItem";
import axios from "axios";
import { apiCall_domain } from "../api";
import Spinner from "../Spinner/Spinner";
import { createGlobalStyle } from "styled-components";
import PriceWrapper from "./PriceWrapper";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";

class ShoppingCart extends Component {
  state = {
    pageSpinner: true,
    products: [],
    refrsh: false,
    noItem: "",
    noSeccondDetails: false,
    noFirstDetails: false,
    noServiceItem: true,
    value: true,
    display: false,
    deletedItemId: null,
    ShowDetailMore: false,
    count: 0,
    costs: null,
    loading: false,
    haveOrg: false,
  };

  componentDidMount() {
    this.getShoppingCart();
  }
  getShoppingCart = () => {
    const config = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/shopping-cart`, {
        headers: config,
      })
      .then((res) => {
        this.setState({ pageSpinner: true }, () => {
          const items = [];
          res.data.data.types.map((type) => {
            items.push(...type.items);
          });
          let withServiceProducts = [];
          let withOutServiceProducts = [];
          let hasTire = false;
          let hasService = false;
          let hasWithoutService = false;
          items.map((product) => {
            if (product.is_tire == 1) {
              hasTire = true;
            }
            let item;
            if (product.install_need == 1) {
              hasService = true;
              if (product.service_type == 1) {
                item = {
                  ...product,
                  name: product.name,
                  count: product.count,
                  address: product.address,
                  time_id: product?.time?.id,
                  id: product.vendor_item_id,
                  date: product.date.gregorian,
                  vendor_id: product.vendor_id,
                  address_id: product.address_id,
                  install_need: product.install_need,
                  service_type: product.service_type,
                  time: product?.time,
                  dates: product.date,
                  is_organization: product.is_organization,
                };
              }
              if (product.service_type == 0) {
                item = {
                  ...product,
                  name: product.name,
                  count: product.count,
                  depot: product.depot,
                  time_id: product?.time?.id,
                  time: product?.time,
                  is_organization: product.is_organization,

                  id: product.vendor_item_id,
                  depot_id: product.depot_id,

                  date: product.date.gregorian,
                  vendor_id: product.vendor_id,
                  install_need: product.install_need,
                  service_type: product.service_type,
                  dates: product.date,
                };
              }
              withServiceProducts.push(item);
            } else {
              hasWithoutService = true;
              item = {
                ...product,
                count: product.count,
                id: product.vendor_item_id,
                is_organization: product.is_organization,

                install_need: product.install_need,
              };
              withOutServiceProducts.push(item);
            }
          });
          this.calculate(
            [...withOutServiceProducts, ...withServiceProducts],
            0,
            this.state.selectedAddress?.id || null,
            this.state.selectedDelivery || 1,
            this.state.discountCode || null,
          );

          this.setState({
            products: [...withOutServiceProducts, ...withServiceProducts],
            pageSpinner: false,
            haveOrg: [...withOutServiceProducts, ...withServiceProducts].find(
              (p) => p.is_organization === 1,
            )
              ? true
              : false,
          });
        });

        //   const config = {
        //     Authorization: getApiKey(),
        //     "content-type": "application/json",
        //   };
        //   axios
        //     .get(`${apiCall_domain}/customer/shopping-cart`, {
        //       headers: config,
        //     })
        //     .then((res) => {
        //       const products = [];
        //       res.data.data.types.map((type) => {
        //         products.push(...type.items);
        //       });
        //       this.setState({
        //         products,
        //         pageSpinner: false,
        //         haveOrg: products.find((p) => p.is_organization === 1)
        //           ? true
        //           : false,
        //       });
        //       this.calculate(
        //         products,
        //         1,
        //         this.state.selectedAddress?.id || null,
        //         this.state.selectedDelivery || 1,
        //         this.state.discountCode || null
        //       );
        //     })
        //     .catch((err) => {
        //       toast.error(err?.response?.data?.errors?.items[0], {
        //         duration: 7000,
        //       });
        //     });
        // });
      });
  };

  calculate = async (
    products,
    isMajor,
    addressId = null,
    shipping = 1,
    discountCode = null,
  ) => {
    this.setState({ showDiscount: true });
    const config = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    let itemsList = "";
    products?.map((item, index) => {
      const itemDetail = {
        id: item.id,
        count: item.count,
        install_need: item.install_need,
      };
      if (item.install_need === 1) {
        const installNeedItem = {
          date: item.date,
          time_id: item.time,
          service_type: item.service_type,
          ...(item.address_id
            ? { address_id: item.address_id }
            : { depot_id: item.depot_id }),
        };
        Object.assign(itemDetail, installNeedItem);
      }
      for (const [key, value] of Object.entries(itemDetail)) {
        itemsList += `&items[${index}][${key}]=${value}`;
      }
    });
    await axios
      .get(
        `${apiCall_domain}/customer/orders/calculation?shipping=${shipping}&is_web=1${itemsList}&is_organization=${
          this.state.haveOrg === true ? 1 : 0
        }&is_major=${isMajor}${
          addressId === null ? "" : `&address_id=${addressId}`
        }${
          discountCode === null
            ? this.state.haveOrg === true
              ? ""
              : ""
            : `&discount_code=${discountCode}`
        }`,
        { headers: config },
      )
      .then((res) => {
        this.setState({
          costs: res.data,
          discountLoading: false,
          can_pay_cash: res.data.can_pay_cash,
        });
        if (discountCode) {
          this.setState({
            discountSubmited: true,
            discountLoading: false,
          });
          toast.success("کد تخفیف اعمال شد");
        } else if (discountCode === "") {
          this.setState({
            discountSubmited: false,
            discountLoading: false,
          });
          toast.success("کد تخفیف حذف شد");
        }
      })
      .catch((err) => {
        this.setState({
          discountLoading: false,
        });
        toast.error(err?.response?.data?.errors?.items[0], {
          duration: 7000,
        });
      });
  };
  //FUNCTIONS

  render() {
    const GlobalStyles = createGlobalStyle`body{
      background: #F9F9F9;
    }`;
    return (
      <>
        {this.state.pageSpinner ? (
          <Spinner />
        ) : (
          <>
            <GlobalStyles />
            <Header showSearchBar={true} title={"سبد خرید"} />
            <div className="shopingCartBody">
              <div className="innerShopingCartBody">
                {this.state.products?.length ? (
                  this.state.products.map((product) => (
                    <CartItem
                      getShoppingCart={this.getShoppingCart}
                      data={product}
                      haveOrg={this.state.haveOrg}
                      calculate={this.calculate}
                    />
                  ))
                ) : (
                  <div className="outOfStock">
                    <i className="icon-cart" />
                    سبد خرید شما خالی است
                  </div>
                )}
                <div className="Installed">
                  <PriceWrapper
                    products={this.state.products}
                    costs={this.state.costs}
                  />
                </div>
                <div className="ScoreStar">
                  <div className="Text">
                    با این خرید می توانید 25 امتیاز برای باشگاه مشتریان کسب کنید
                  </div>
                  <div>
                    <img src="/public/assets/star0.svg" alt="pic" />
                  </div>
                </div>
                {this.state.products.length ? (
                  <Link to={"/shoppingCart/checkout"}>
                    <button type="submit" className="btn btn--continue">
                      ادامه خرید
                    </button>
                  </Link>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}
export default ShoppingCart;
